import { OnInit } from "@angular/core";
import { Component } from "@angular/core";

import * as moment from 'moment';

import "ag-grid-angular";
import 'ag-grid-community/dist/styles/ag-grid.css';
import { ActivatedRoute } from '@angular/router';
import * as _ from "lodash";
import { PosHistory } from "../../../core/models/posHistory/pos-history.model";
import { ToastrService } from "ngx-toastr";
import { BankPortalService, PosHistoryViewModel } from "../../../web-api-client";


@Component({
  selector: 'bankportal-reconfigure-history',
  templateUrl: './reconfigure-history.component.html',
})
export class BankPortalReconfigureHistoryComponent implements OnInit {
 loadingIndicator!: boolean;
  columnDefs: any[] = [];
  columns: any[] = [];
  public gridApi;
  public gridColumnApi;
  public defaultColDef;
  public popupParent;
  rows2: PosHistory[] = [];
  rowsCache: PosHistory[] = [];


  constructor(private _toastr: ToastrService, private _route: ActivatedRoute, private bankportalservice: BankPortalService) {
  }

  ngOnInit() {

    this.columnDefs = [
      {
        headerName: 'Deployed Date', field: 'deployDate', valueFormatter: (data) => moment(data.value).format('ll'), width: 128, suppressSizeToFit: true, filter: 'date',
        filterParams: {
          comparator: function (filterLocalDateAtMidnight, cellValue) {
            //using moment js
            var dateAsString = moment(cellValue).format('DD/MM/YYYY');
            var dateParts = dateAsString.split("/");
            var cellDate = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));
            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }

            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
          }
        }
      },
      { headerName: 'Merchant', field: 'merchant', width: 250, suppressSizeToFit: true },
      { headerName: 'Address', field: 'address', width: 180, suppressSizeToFit: true },
      { headerName: 'District', field: 'district', width: 130, suppressSizeToFit: true },
      { headerName: 'Province', field: 'province', width: 150, suppressSizeToFit: true },
      { headerName: 'Terminal ID', field: 'idTerminal', width: 150, suppressSizeToFit: true },
      { headerName: 'Merchant ID', field: 'idMerchant', width: 150, suppressSizeToFit: true, },
      { headerName: 'Model', field: 'item', width: 140, suppressSizeToFit: true },
      { headerName: 'Serial Number', field: 'serialKey', width: 250, suppressSizeToFit: true,  },
      { headerName: 'Application Date', field: 'applicationFormat', width: 180, suppressSizeToFit: true },
      { headerName: 'Connectivity', field: 'connectivity', width: 150, suppressSizeToFit: true },
      { headerName: 'Deployed Location', field: 'merchantLocation', width: 180, suppressSizeToFit: true },
      { headerName: 'Contact No', field: 'contactNo1', width: 150, suppressSizeToFit: true, },
      { headerName: 'Contact Person', field: 'contactPerson', width: 150, suppressSizeToFit: true },
      // { headerName: 'Email Address', field: 'outlet', width: 150, suppressSizeToFit: true},

    ];
    this.loadPosHistorysData();

  }


  onBtnExport() {
    this.gridApi.exportDataAsCsv();
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

  }


  onSearchChanged(value: string) {
    // this.rows2 = this.rowsCache.filter(r => Utilities.searchArray(value, false, r.merchant, r.idMerchant, r.idTerminal, r.item, r.address, r.contactPerson, r.serialKey));
  }


  onDataLoadFailed(error: any) {
    this._toastr.error(`Unable to retrieve users from the server`,"Load Error");
  }

  loadPosHistorysData() {
    // this.alertService.startLoadingMessage();
    this.loadingIndicator = true;
    this.bankportalservice.bankPortal_GetRetrievedHistory().subscribe(results => this.onDataLoadSuccessful(results), error => this.onDataLoadFailed(error));
  }
  onDataLoadSuccessful(posHistory: PosHistoryViewModel[]) {
    // this.alertService.stopLoadingMessage();
  }
  gridOptions = {
    rowSelection: 'multiple',
    enableSorting: 'true',
    enableColResize: 'true',
    enableRtl: 'true',
    pagination: 'true',
    paginationAutoPageSize: 'true',
    animateRows: 'true',
    rowClicked: 'true',
    enableCellTextSelection: 'true'
  }

}
